module.exports = __webpack_public_path__ + "32ce439f.png";